import { fuego } from "@nandorojo/swr-firestore";

// eslint-disable-next-line import/prefer-default-export
export async function deleteFileAtPath(path: string) {
  return fuego.storage().ref(path).delete()
}